import * as React from 'react'
import { IPeerGroupTabsProps, IVisualizationState, roundNumber } from '../../lib/http'
import PanelGraph from 'app/components/tabs/PanelGraph'

export class VisualizationFour extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    title: '',
    data: [],
    categories: [],
    series: [],
    loading: false,
    filters: { assetLevel: 0 },
  }

  componentDidMount() {
    this.loadSeries()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      //NOTE: Don't need to display All Foundations on this chart
      const dataWithoutAll = this.props.data.filter(dataPoint => dataPoint['filterId'] > 0)
      this.setState({ filters: this.props.filters, data: dataWithoutAll }, () => {
        this.loadSeries()
      })
    }
  }

  loadSeries() {
    const { data } = this.state

    const categories = data.map(dataPoint => dataPoint['Giv_T_V4_ColName'])
    const aggregate = data.map(dataPoint => roundNumber(dataPoint['Giv_N_V4_AggregtPct'] * 100.0, 1))
    const average = data.map(dataPoint => roundNumber(dataPoint['Giv_N_V4_AvgPct'] * 100.0, 1))
    const median = data.map(dataPoint => roundNumber(dataPoint['Giv_N_V4_MedianPct'] * 100.0, 1))
    const title = data && data.length > 0 ? data[0]['Giv_T_V4_Vis4Title'] : ''

    const series = [{ color: '#DBDBDB', name: 'Aggregate', data: aggregate }, { color: '#BDD7EE', name: 'Average', data: average }, { color: '#C6E0B4', name: 'Median', data: median }]

    this.setState({ title, categories, loading: false, series })
  }

  static getPublicIndexConfig(series, categories, title) {
    return {
      chart: { type: 'line' },
      title: {
        text: title
      },
      xAxis: {
        categories
      },
      yAxis: {
        visible: true,
        opposite: false,
        title: '',
        labels: {
          format: '{value}%',
        },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            format: '{y}%',
          },
        }
      },
      legend: { enabled: true },
      credits: { enabled: false },
      series
    }
  }

  render() {
    const { loading, categories, series, title } = this.state
    return (
      <PanelGraph title="" loading={loading} chartConfig={VisualizationFour.getPublicIndexConfig(series, categories, title)} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/GIV/VisualizationFour/index.tsx